/* eslint-disable react/require-default-props */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

class NonAuthLayout extends Component {
  static capitalizeFirstLetter = (string) => string.charAt(1).toUpperCase() + string.slice(2);

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{this.props.children}</>;
  }
}

NonAuthLayout.propTypes = {
  children: PropTypes.object,
};

export default withRouter(NonAuthLayout);
